module.exports = __webpack_public_path__ + "static/img/rank_charm_bg.4700cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_charm_bg.png
// module id = TvKy
// module chunks = 0